import { ResetPasswordTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ResetPasswordTrackingSchema: Record<
  ResetPasswordTrackingPoint,
  string
> = {
  [ResetPasswordTrackingPoint.PageView]: '',
  [ResetPasswordTrackingPoint.NextButtonClick]: '',
  [ResetPasswordTrackingPoint.HelpButtonClick]: '',
  [ResetPasswordTrackingPoint.BackButtonClick]: '',
  [ResetPasswordTrackingPoint.ContactUsButtonClick]: '',
  [ResetPasswordTrackingPoint.CaptchaPopupImpression]: '',
  [ResetPasswordTrackingPoint.CaptchaPopupOkButtonClick]: '',
  [ResetPasswordTrackingPoint.CaptchaPopupCancelButtonClick]: '',
  [ResetPasswordTrackingPoint.CaptchaPopupRefreshButtonClick]: '',
  [ResetPasswordTrackingPoint.ResetPasswordOnShopeeView]: '',
  [ResetPasswordTrackingPoint.ResetPasswordOnShopeeOkClick]: '',
  [ResetPasswordTrackingPoint.ResetPasswordOnShopeeContactUsClick]: '',
  [ResetPasswordTrackingPoint.ResetPasswordOnShopeeCancelClick]: '',
  [ResetPasswordTrackingPoint.ResetPasswordSuccessAction]: '',
};

export const getResetPasswordPageTypeAndSchema = (
  trackingPoint: ResetPasswordTrackingPoint
) => {
  return {
    page_type: PageType.ResetPasswordPage,
    schema: ResetPasswordTrackingSchema[trackingPoint],
  };
};
